import { Modal, Button, Select, Tooltip } from 'antd';
import React, { useCallback, useRef, useEffect, useState } from 'react';
import { ACCOUNT, getExperienceBasedQuestions } from '../../redux/actions/accountActions';
import { useDispatch, useSelector } from 'react-redux';
import { isSafariBrowser } from '../../helpers/Helpers';

const { Option } = Select;

const ExperienceBasedQuestionsPopup = ({
    bodyStyles = {},
    handleAskExperienceBasedQuestion,
    handleSkipExperienceBasedQuestion,
    maskClosable,
}) => {
    const dispatch = useDispatch();

    const modalRef = useRef(null);
    const questionRef = useRef(null);

    const { isOpened, university, id, name, type, items, universitySettings } = useSelector(
        (state) => state.experienceBasedQuestionsPopup
    );
    const { institution } = useSelector((state) => state.widget);

    const [categoryQuestions, setCategoryQuestions] = useState(null);
    const [questionToAsk, setQuestionToAsk] = useState('');

    const isAllowToSkip = institution
        ? !institution?.isAllowedToSkipExperienceBasedQuestions
        : !universitySettings?.isAllowedToSkipExperienceBasedQuestions;
    const isEnabled =
        institution?.isEnabledExperienceBasedQuestions || universitySettings?.isEnabledExperienceBasedQuestions;

    useEffect(() => {
        let timeout;
        const isSafari = isSafariBrowser();
        if (isOpened) {
            if (!items) {
                dispatch(getExperienceBasedQuestions());
            }
            if (modalRef.current) {
                isSafari
                    ? window.parent.postMessage('safariScrollToTop', '*')
                    : modalRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else {
                timeout = setTimeout(() => {
                    if (isSafari) {
                        window.parent.postMessage('safariScrollToTop', '*');
                    } else if (modalRef.current) {
                        modalRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }, 500);
            }
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [isOpened]);

    useEffect(() => {
        if (items) {
            setCategoryQuestions(items[0].questions);
            setQuestionToAsk(items[0].questions[0].question);
        }
    }, [items, isOpened]);

    const handleChangeCategory = useCallback(
        (key) => {
            const selectedCategory = items && items.find((questionItem) => questionItem.category === key).questions;
            setCategoryQuestions(selectedCategory);
            if (questionRef.current) {
                questionRef.current.rcSelect.state.value = [selectedCategory[0].id];
                setQuestionToAsk(selectedCategory[0].question);
            }
        },
        [items]
    );

    const handleSelectQuestion = useCallback((val, obj) => {
        const { props } = obj.props.children;
        setQuestionToAsk(props.title);
    }, []);

    const handleClosePopup = useCallback(() => {
        dispatch({
            type: ACCOUNT.CLOSE_EXPERIENCE_BASED_QUESTIONS_POPUP,
        });
    }, [dispatch]);

    const onAskQuestion = useCallback(() => {
        dispatch({
            type: ACCOUNT.CLOSE_EXPERIENCE_BASED_QUESTIONS_POPUP,
        });
        handleAskExperienceBasedQuestion && handleAskExperienceBasedQuestion({ university, id, name, questionToAsk });
    }, [university, id, name, questionToAsk]);

    const onSkipQuestion = useCallback(() => {
        dispatch({
            type: ACCOUNT.CLOSE_EXPERIENCE_BASED_QUESTIONS_POPUP,
        });
        dispatch({
            type: ACCOUNT.SKIP_EXPERIENCE_BASED_QUESTION,
            payload: {
                isSkipped: true,
            },
        });
        handleSkipExperienceBasedQuestion && handleSkipExperienceBasedQuestion({ university, id, name });
    }, [university, id, name]);

    if (!university) {
        return null;
    }

    return (
        <Modal
            open={isOpened && isEnabled}
            styles={{ body: { padding: 0 } }}
            width={470}
            footer={null}
            closable={maskClosable}
            maskClosable={maskClosable}
            onCancel={handleClosePopup}
            className="register-modal"
        >
            <div ref={modalRef} className="sign-up-1 padding">
                <h2 className="modal-name">What do you want to ask about to {name}</h2>
                <div>
                    <Select
                        defaultValue="Events"
                        className="modal-select"
                        style={{
                            width: '100%',
                            marginBottom: '2rem',
                            marginTop: '4rem',
                        }}
                        onChange={handleChangeCategory}
                    >
                        {items &&
                            items.map((item) => {
                                return (
                                    <Option key={item.category} value={item.category}>
                                        <Tooltip title={item.category} placement="right">
                                            {item.category}
                                        </Tooltip>
                                    </Option>
                                );
                            })}
                    </Select>
                    <Select
                        ref={questionRef}
                        className="modal-select"
                        defaultValue={11}
                        style={{
                            width: '100%',
                            marginBottom: '4rem',
                        }}
                        onChange={handleSelectQuestion}
                    >
                        {categoryQuestions &&
                            categoryQuestions.map((question) => {
                                return (
                                    <Option key={question.id} value={question.id} label={question.question}>
                                        <Tooltip title={question.question} placement="right">
                                            {question.question}
                                        </Tooltip>
                                    </Option>
                                );
                            })}
                    </Select>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', padding: '0 5rem' }}>
                    <Button className="primary-btn" type="primary" onClick={onAskQuestion}>
                        Ask this question
                    </Button>
                    {isAllowToSkip && (
                        <Button className="link-btn" type="link" style={{ marginTop: '5rem' }} onClick={onSkipQuestion}>
                            Skip and write my own question
                        </Button>
                    )}
                </div>
            </div>
        </Modal>
    );
};

export default ExperienceBasedQuestionsPopup;
